import { useState } from "react";
import "antd/dist/reset.css";
import "../../containers/customLayout.css";
import "../../App.css";
import './VolunteerScientist.css';
import { CheckOutlined } from "@ant-design/icons";

import { Col, Row, Image, Button, List, Card } from "antd";

import { ParagraphHeader } from "@seims/shared";
import { programmes } from "../../utils/apiConstants";
import { useNavigate } from "react-router-dom";
import Meta from "antd/es/card/Meta";

const VolunteerScientistView = () => {
  const [visible, setVisible] = useState(false);

  const programme = programmes.find((p) => p.key === "volunteer-scientist");
  const data = [
    'Biographical Information',
    'Requirement 2',
    'Requirement 3',
    'Requirement 4',
    'Requirement 5',
  ];

  const showModal = (value) => {
    setVisible(value);
  };

  const navigate = useNavigate();
  return (
    <>
      {/* <div className="volunteer-header">
        <div>
          <Image
            src={require("../../assets/volunteer-graphic-edits.png")}
            preview={false}
            alt="Volunteer Scientist"
            style={{
              maxHeight: "500px"
            }}
          />
        </div>
      </div> */}
      <Row>
        <Col xs={24}>
          <div className="center-align">
            <Image
              src={require("../../assets/volunteer-graphic-edits.png")}
              alt="Volunteer Scientist"
              preview={false}
            />
          </div>
        </Col>
      </Row>
      <div className="volunteer-roles" style={{ paddingTop: "16px", paddingBottom: "10px" }}>
        <ParagraphHeader header="Volunteer Scientists / STEM Professionals & Volunteerism Roles" />
        <Row style={{ justifyContent: "center", paddingTop: "16px" }}>
          <Col xs={22} sm={18} md={18} style={{ display: "flex", justifyContent: "center" }}>
            <p>
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing
            </p>
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", paddingTop: "20px" }}>
          <Col xs={24} sm={18} style={{ display: "flex", justifyContent: "left" }}>
            <h2 style={{ fontSize: "20px" }}>A few simple steps to become a volunteer</h2>
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", padding: '10px' }} >
          <Col xs={24} sm={18} >

            <div className="step-container" style={{ marginTop: "20px" }}>
              <div className="step-number">1</div>
              <p className="step-text">Provide us with some personal information</p>
            </div>

            <div className="step-container">
              <div className="step-number">2</div>
              <p className="step-text">Provide us with some professional information</p>
            </div>

            <div className="step-container">
              <div className="step-number">3</div>
              <p className="step-text">Any previous experience in volunteering? What volunteerism role are you interested in?</p>
            </div>
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", paddingTop: "20px", paddingBottom: "20px" }}>
          <Col xs={24} sm={18} style={{ display: "flex", justifyContent: "left" }}>
            <h2 style={{ fontSize: "20px" }}>Volunteerism Roles</h2>
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", paddingBottom: "0px" }} >
          <Col xs={24} sm={18} > 
          {/* <div className="volunteer-features"> */}
          <Row style={{ justifyContent: "center", paddingBottom: "50px" }} >
          <Col xs={24} sm={12} md={12} lg={8}>
            <div className="volunteer-feature">
              <Image
                alt="image"
                width={80}
                src={require('../../assets/role-model.png')}
                preview={false}
                style={{ display: "inline-block" }}
              />
              <h3 className="volunteer-feature-title">Role-model</h3>
            </div>
          </Col>
          <Col xs={24} sm={12} md={12} lg={8}>
            <div className="volunteer-feature">
              <Image
                alt="image"
                preview={false}
                width={80}
                src={require(`../../assets/mentor.png`)}
                style={{ display: "inline-block" }}
              />
              <h3 className="volunteer-feature-title">Mentoring</h3>
            </div>
          </Col>
          <Col xs={24} sm={12} md={12} lg={8}>
            <div className="volunteer-feature">
              <Image
                alt="image"
                preview={false}
                width={80}
                src={require(`../../assets/megaphone.png`)}
                style={{ display: "inline-block" }}
              />
              <h3 className="volunteer-feature-title">Facilitator Communicator Exhibitor</h3>
            </div>
          </Col>
          {/* </div> */}


          <Col xs={24} sm={12} md={12} lg={8}>
            {/* <div className="volunteer-features"> */}
              <div className="volunteer-feature">
                <Image
                  alt="image"
                  preview={false}
                  width={80}
                  src={require(`../../assets/learning.png`)}
                  style={{ display: "inline-block" }}
                />
                <h3 className="volunteer-feature-title">Creation of teaching/learning materials</h3>
              </div>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8}> 
              <div className="volunteer-feature">
                <Image
                  alt="image"
                  preview={false}
                  width={80}
                  src={require(`../../assets/teach.png`)}
                  style={{ display: "inline-block" }}
                />
                <h3 className="volunteer-feature-title">Extra-tuition</h3>
              </div>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8}>
              <div className="volunteer-feature">
                <Image
                  alt="image"
                  preview={false}
                  width={80}
                  src={require(`../../assets/exibit.png`)}
                  style={{ display: "inline-block" }}
                />
                <h3 className="volunteer-feature-title">Exhibit Builder</h3>
              </div>
              </Col>
              </Row>
            </Col>
        </Row>
      </div >

      <div className="volunteer-get-involved" style={{ paddingTop: "16px", paddingBottom: "20px" }}>
        <ParagraphHeader header="Get Involved" />
        <Row style={{ justifyContent: "center", paddingTop: "0px"}}>
          <Col xs={10} md={12} lg={6} style={{ display: "flex", justifyContent: "center" }}>
            <Image
              style={{ maxWidth: '250px', border: "1px solid #707070" }}
              src={require("../../assets/get_involved.jpg")}
              preview={false}
              alt="SEIMS Volunteer Scientists"
            />
          </Col>
          <Col xs={22} md={22} lg={8} style={{ paddingTop: "20px" }}>
            <p style={{ fontSize: "18px", textAlign: "center" }}>Are you a Scientist or Engineer looking to give back to your community?</p>
            <p style={{ fontSize: "18px", textAlign: "center" }}>Register now for the oportunity to volunteer in the Science engagement programme</p>
            <div className="extra-information-links" style={{ textAlign: "center", paddingBottom: "10px" }}>
            </div>
            <div className="extra-information-links" style={{ textAlign: "center" }}>
              <Button className="get-involved-button" shape="round" onClick={() => navigate("/register")}>Register</Button>&nbsp;&nbsp;
            </div>
          </Col>
        </Row>
        <p></p>
      </div>

      <div className="programme-download" style={{ paddingTop: "16px", paddingBottom: "30px" }}>
        <ParagraphHeader header="Why should you register" />
        <p style={{ fontSize: "20px", textAlign: "center" }}>See below the various activities that volunteers have helped with</p>
        <Row style={{ justifyContent: "center", paddingTop: "16px" }}>
          <Col xs={20} sm={12} md={6} style={{ display: "flex", justifyContent: "center", marginLeft: "10px", marginRight: "30px", paddingBottom: "10px" }}>
            <Card>
              <Image
                src={require("../../assets/stemi.jpg")}
                preview={false}
                alt="SEIMS Volunteer Scientists"
              />
              <Meta
                title="SEIMS Volunteer Scientists"
                style={{ marginTop: "-6px"}}
                className="activities"
              />
              <br></br>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
              </p>
            </Card>
          </Col>
          <Col xs={20} sm={12} md={6} style={{ display: "flex", justifyContent: "center", marginLeft: "10px", marginRight: "30px", paddingBottom: "10px" }}>
            <Card>
              <Image
                src={require("../../assets/nsw.jpg")}
                preview={false}
                alt="National Science Month"
              />
              <Meta
                title="SEIMS Volunteer Scientists"
                style={{ marginTop: "-6px" }}
                className="activities"
              />
              <br></br>
              <p >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
              </p>
            </Card>
          </Col>
          <Col xs={20} sm={12} md={6} style={{ display: "flex", justifyContent: "center", marginLeft: "10px", marginRight: "30px", paddingBottom: "10px" }}>
            <Card>
              <Image
                src={require("../../assets/robotics.jpg")}
                preview={false}
                alt="Coding and Robotics"
              />
              <Meta
                title="SEIMS Volunteer Scientists"
                style={{ marginTop: "-6px" }}
                className="activities"
              />
                
              <p >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
              </p>
            </Card>
          </Col>
        </Row>
      </div>

      <div className="volunteer-requirements" style={{ paddingTop: "16px", paddingBottom: "50px" }}>
        <ParagraphHeader header="What do you need to register?" />
        <Row style={{ justifyContent: "center", paddingTop: "16px" }}>
          <Col xs={8} sm={7} md={10} lg={8}  style={{ display: "flex", justifyContent: "center" }}>
            <Image
              className="cv-img"
              style={{ maxWidth: '250px' }}
              src={require("../../assets/cv.png")}
              preview={false}
              alt="Volunteer Scientists"
            />
          </Col>
          <Col xs={18} sm={10} md={9} lg={8} style={{ paddingLeft: "20px" }} >
            <List
              dataSource={data}
              renderItem={item => (
                <List.Item>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CheckOutlined />&nbsp; &nbsp; &nbsp;<span> {item}</span>
                  </div>
                </List.Item>
              )}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default VolunteerScientistView;
